// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DHMG","col":"styles_col__1uA8r"};